import React from 'react';
import { HelpModalContentBody } from '@Components/HelpModal/HelpModal.style';
import { textblocks } from 'seal-ui-components';

const ClausesHelpModalContent = () => (
    <HelpModalContentBody>
        <textblocks.Heading3>Clauses</textblocks.Heading3>
        <p>
            Clauses are suggested or approved contractual language, added and configured through the
            Insight platform. Once added, they are visible in this area of the add-in, arranged by
            Group. The Groups are displayed alphabetically. Expand a Clause Group to view all
            Clauses and Clause Groups nested within that Group. Expand a specific Clause to view the
            description and preview the language itself.
        </p>
        <textblocks.Heading3>Clause Groups</textblocks.Heading3>
        <p>
            Clause Groups represent the high-level topics that encompass a set of related clauses.
            Groups can be nested, containing more granular groupings within the overarching Group.
        </p>

        <textblocks.Heading3>Show Clause Details</textblocks.Heading3>
        <p>
            When viewing a Clause Group, the user will first see the Clause Group name. Expanding
            the name will display the Description and a preview of the Primary Language. Click
            &apos;Show more details&apos; to see the full text of longer Clauses including any
            fallback language.
        </p>

        <textblocks.Heading3>Primary/Fallback language</textblocks.Heading3>
        <p>
            Each Clause Group can contain multiple Clauses. One of these Clauses will be labeled
            Primary Language, while all other Clauses in the group will be labeled as Fallback
            Clauses.
        </p>
        <textblocks.Heading3>Filter</textblocks.Heading3>
        <p>
            You can filter for clause group names, clause texts and clause descriptions. Filtering
            is case insensitive and will match parts of the word. When using # tags it will only
            match on the beginning or full word.
        </p>
        <textblocks.Heading4>Operators</textblocks.Heading4>
        <dl>
            <dt>+</dt>
            <dd>Require this term in the result.</dd>
            <dt>-</dt>
            <dd>Exclude this term from the result.</dd>
            <dt>␣</dt>
            <dd>Space between terms is equivalent to OR (default operator).</dd>
        </dl>
        <div>
            The following characters will be excluded in the search
            <ul>
                <li>
                    <p>[~`!@$%^&amp;*()&#123;&#125;[\];:&quot;&apos;&lt;&#44;.&gt;?/\\|=]</p>
                </li>
            </ul>
        </div>
    </HelpModalContentBody>
);

export default ClausesHelpModalContent;
